// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__kTQVb","content":"Consent_content__U2gHM","footer":"Consent_footer__3w56n"};